module.exports = __webpack_public_path__ + "img/signup_choose_company_icon_01.81da27fd.png";